import { render, staticRenderFns } from "./PoveznicaDataDetails.vue?vue&type=template&id=b42f9dba&scoped=true&"
import script from "./PoveznicaDataDetails.vue?vue&type=script&lang=js&"
export * from "./PoveznicaDataDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42f9dba",
  null
  
)

export default component.exports